<template>
  <div>
    <img v-if="tracker !== null" :src="tracker"/>
  </div>
</template>

<script>
export default {
  computed: {
    host () {
      return this.url.host
    },
    path () {
      return this.url.pathname
    },
    segments () {
      return this.path.split('/').slice(1)
    },
    section () {
      if (this.segments.length > 0) {
        return this.segments[0]
      }
      return null
    },
    code () {
      if (this.segments.length > 1 && (this.segments[0] === 'blogs' || this.segments[0] === 'collections')) {
        return this.segments[1]
      }
      return null
    },
    tracker () {
      let base = 'https://commerce.souler.com/eye'

      let params = new URLSearchParams()
      params.append('uuid', this.uuid)
      params.append('section', this.section)
      params.append('code', this.code)

      return base + '?' + params.toString()

    }
  },
  data () {
    return {
      uuid: null,
      url: new URL(window.location.href)
    }
  },
  methods: {
    initialize () {
      let uuid = sessionStorage.getItem('uuid');
      if (uuid === null) {
        this.uuid = this.$uuid.v4()
        sessionStorage.setItem('uuid', this.uuid)
      } else {
        this.uuid = uuid
      }
    },
    generateUuid () {

    }
  },
  mounted () {
    this.initialize()
  }
}
</script>
